var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19826 14.727L4.24051 11.3413L3.51634 10.5123H4.61706H16.0598C18.7099 10.5123 20.8652 12.6675 20.8652 15.3174C20.8652 17.9674 18.7099 20.1226 16.0598 20.1226H11.1508C10.9754 20.1226 10.8333 20.2646 10.8333 20.44C10.8333 20.6153 10.9754 20.7574 11.1508 20.7574H16.0598C19.0588 20.7574 21.5 18.3164 21.5 15.3174C21.5 12.3184 19.0591 9.87749 16.0598 9.87749H4.61706H3.51635L4.24051 9.04853L7.19811 5.66297L7.19826 14.727ZM7.19826 14.727C7.19827 14.727 7.19828 14.7271 7.19829 14.7271C7.31363 14.8592 7.30004 15.0596 7.16802 15.1749L7.16798 15.1749M7.19826 14.727L7.16798 15.1749M7.16798 15.1749C7.10731 15.2279 7.0338 15.2534 6.95961 15.2534C6.87043 15.2534 6.78304 15.2167 6.71973 15.1445C6.7197 15.1444 6.71967 15.1444 6.71964 15.1444L2.57847 10.4038L2.57831 10.4036M7.16798 15.1749L2.57831 10.4036M2.57831 10.4036C2.4739 10.2842 2.4739 10.1058 2.57831 9.98642L2.57847 9.98624M2.57831 10.4036L2.57847 9.98624M2.57847 9.98624L6.71982 5.24547C6.71985 5.24544 6.71988 5.2454 6.71991 5.24536C6.8356 5.11325 7.03601 5.09988 7.168 5.21489C7.29977 5.32998 7.31356 5.53043 7.19829 5.66275L2.57847 9.98624Z",
    fill: "black",
    stroke: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.d94c4dd8aa00b49dd3cbc89cda81fe76.svg";
export { ForwardRef as ReactComponent };